import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from 'src/componentes/dropdown';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';

import useAuth from 'src/hooks/useAuth';
import Avatar from 'src/componentes/avatar';

function NavbarUser() {
  const history = useHistory();
  const intl = useIntl();

  const { user, logout} = useAuth();

  // Um gatilho só: com dois (mobile e desktop), o Radix ancora o menu no
  // último montado, que fica escondido no mobile.
  return (
    <UncontrolledDropdown className="nav-item">
      <DropdownToggle asChild>
        <a
          role="button"
          tabIndex={0}
          className="nav-link d-flex align-items-center p-0 tw:cursor-pointer"
        >
          <div className="d-none d-sm-block mr-2 text-right text-dark">
            <strong>{user?.nome}</strong>
          </div>
          <Avatar
            semMargin
            semEstilo
            foto={user?.fotoArquivo}
            size={24}
            showLabel={false}
            label={user?.nome}
          />
        </a>
      </DropdownToggle>
      <DropdownMenu end>
        <DropdownItem
          onClick={() => history.push('/minhas-informacoes/meus-dados')}
        >
          {intl.formatMessage({ id: 'label.meusDados' })}
        </DropdownItem>
        <DropdownItem divider />
        <DropdownItem onClick={() => logout()}>
          {intl.formatMessage({ id: 'label.sair' })}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
}

export default NavbarUser;
